import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { cloneQueryGroup, generateQuery, validateQuery } from '../utils/query-helper';
import { QueryConfigurationService } from '../services/configuration.service';
var PlainComponent = (function () {
    function PlainComponent(config, cdRef) {
        this.config = config;
        this.cdRef = cdRef;
    }
    Object.defineProperty(PlainComponent.prototype, "queryTemplate", {
        get: function () {
            return this._queryTemplate;
        },
        set: function (val) {
            this._queryTemplate = val;
            this._tempQueryTemplate = cloneQueryGroup(this._queryTemplate);
            this.rules = this.getRules(this._tempQueryTemplate);
        },
        enumerable: true,
        configurable: true
    });
    PlainComponent.prototype.ngAfterViewInit = function () {
        this.cdRef.detectChanges();
    };
    PlainComponent.prototype.reset = function () {
        this.queryTemplate = this._queryTemplate;
    };
    PlainComponent.prototype.getQuery = function () {
        return generateQuery(this._tempQueryTemplate, false);
    };
    PlainComponent.prototype.getOriginalQuery = function () {
        return generateQuery(this._tempQueryTemplate, true);
    };
    PlainComponent.prototype.validateQuery = function () {
        return validateQuery(this._tempQueryTemplate);
    };
    PlainComponent.prototype.getRules = function (group) {
        var rules = [];
        if (group.rules && group.rules !== null && group.rules.length > 0) {
            rules = rules.concat(group.rules);
        }
        if (group.groups && group.groups !== null && group.groups.length > 0) {
            for (var _i = 0, _a = group.groups; _i < _a.length; _i++) {
                var child = _a[_i];
                rules = rules.concat(this.getRules(child));
            }
        }
        return rules;
    };
    return PlainComponent;
}());
export { PlainComponent };
PlainComponent.decorators = [
    { type: Component, args: [{
                selector: 'ngx-query-plain',
                template: "\n    <div class=\"form-row\">\n      <div class=\"form-group col-md-6\" *ngFor=\"let rule of rules\">\n        <div class=\"row\">\n          <label class=\"col-md-3 col-form-label text-right\">{{rule.field.label}}</label>\n          <div class=\"col-md-9\">\n            <ng-container *ngIf=\"rule.op!='bt'\" [ngTemplateOutlet]=\"rule.field.valueInputTemplate\"\n              [ngOutletContext]=\"{rules:rules, rule:rule, dataIndex:0, custom: rule.field.custom}\"></ng-container>\n            <div *ngIf=\"rule.op=='bt'\" class=\"row\">\n              <div class=\"col\">\n                <ng-container [ngTemplateOutlet]=\"rule.field.valueInputTemplate\"\n                  [ngOutletContext]=\"{rules:rules, rule:rule, dataIndex:0,\n                    custom: rule.field.custom, placeholder: config.labels.misc.from}\">\n                </ng-container>\n              </div>\n              <div class=\"col\">\n                <ng-container [ngTemplateOutlet]=\"rule.field.valueInputTemplate\"\n                  [ngOutletContext]=\"{rules:rules, rule:rule, dataIndex:1,\n                    custom: rule.field.custom, placeholder: config.labels.misc.to}\">\n                </ng-container>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  "
            },] },
];
/** @nocollapse */
PlainComponent.ctorParameters = function () { return [
    { type: QueryConfigurationService, },
    { type: ChangeDetectorRef, },
]; };
PlainComponent.propDecorators = {
    'queryTemplate': [{ type: Input },],
};
//# sourceMappingURL=plain.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@zhongruigroup_ngx-query@1.0.1@@zhongruigroup/ngx-query/plain/plain.component.js
// module id = null
// module chunks = 